<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        style="margin-right: 10px"
        v-model="screen.park_id"
        placeholder="请选择园区"
        :disabled="userInfo.park_id != 0"
        @change="parkChange"
        ><el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        :disabled="screen.park_id == ''"
        class="screenInput"
        v-model="screen.company_id"
        placeholder="请选择企业名称"
      >
        <el-option label="全部企业" value=""></el-option>
        <el-option
          :label="item1.name"
          :value="item1.id"
          v-for="(item1, index1) in screenCompanyList"
          :key="index1"
        ></el-option>
      </el-select>
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.legal_search"
        placeholder="请输入业主姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-input
        style="margin-right: 10px; width: 200px"
        v-model="screen.apply_search"
        placeholder="请输入申请人姓名/手机号"
        maxlength="11"
      ></el-input>
      <el-button type="primary" plain @click="reset()">重置</el-button>
      <el-button type="primary" @click="(screen.page = 1), fetchData()">搜索</el-button>
    </div>

    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="企业名称" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.apply">
            <span>{{ scope.row.applycompany ? scope.row.company.name : "--" }}</span>
          </span>
          
        </template>
      </el-table-column> -->
      <el-table-column label="房间号" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.apply">
            <span v-if="scope.row.apply.houses.length">
              <div
                class="line2"
                v-for="(item, i) in scope.row.apply.houses"
                :key="i"
              >
                {{ item.house_name }}
              </div>
            </span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="业主姓名" min-width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.apply">
            {{ scope.row.apply.legal_name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="业主手机号码" min-width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.apply">
            {{ scope.row.apply.legal_phone }}
          </span>
          <!-- {{ scope.row.legal_phone }} -->
        </template>
      </el-table-column>
      <el-table-column label="巡检人类型" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.patrol_type == 1 ? "人" : "角色" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="巡检人/角色" min-width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.patrol_type == 1">{{
            scope.row.patrol_user ? scope.row.patrol_user.name : ""
          }}</span>
          <span v-if="scope.row.patrol_type == 2">{{
            scope.row.patrol_role ? scope.row.patrol_role.title : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="审核管理员" min-width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.system_admin ? scope.row.system_admin.username : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="装修状态" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.apply">
            {{
              scope.row.apply.status == 4
                ? "装修中"
                : scope.row.apply.status == 5
                ? "待验收"
                : scope.row.apply.status == 6
                ? "已完成"
                : "--"
            }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="是否开启扫码" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.is_scan == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.is_scan == 1 ? "开启" : "不开启" }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.status == '1' ? 'success' : 'danger'"
            disable-transitions
            >{{ scope.row.status == 1 ? "启用" : "停用" }}</el-tag
          >
        </template>
      </el-table-column> -->
      <el-table-column prop="created_at" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleInfo(scope.row)"
            v-if="roles.includes('/renovation/task_detail')"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>
    <el-drawer
      size="800px"
      :title="drawerTitle"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleClose"
    >
      <div class="codeBox">
        <img class="codeImg" :src="imageUrl + ruleForm.qrcode" alt="" />
        <div class="btnBox">
          <el-button
            type="primary"
            @click="downloadByBlob(imageUrl + ruleForm.qrcode)"
            >下载二维码</el-button
          >
          <el-button type="success" @click="register()">巡检登记</el-button>
        </div>
      </div>

      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <h3 style="padding-left: 30px">装修巡检设置</h3>
        <el-form-item label="园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            :disabled="czType == 'see' || userInfo.park_id != 0"
            @change="formParkChange"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否需要扫码" prop="is_scan">
          <el-radio-group
            v-model="ruleForm.is_scan"
            :disabled="czType == 'see'"
          >
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="2">不开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="任务状态" prop="status">
          <el-radio-group v-model="ruleForm.status" :disabled="czType == 'see'">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="巡检人类型" prop="patrol_type">
          <el-radio-group
            v-model="ruleForm.patrol_type"
            :disabled="czType == 'see'"
          >
            <el-radio :label="1">人</el-radio>
            <el-radio :label="2">角色</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="巡检人"
          prop="patrol_user_id"
          v-if="ruleForm.patrol_type == 1"
        >
          <el-select
            :disabled="czType == 'see'"
            filterable
            v-model="ruleForm.patrol_user_id"
            placeholder="巡检人"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in userList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="巡检角色"
          prop="patrol_role_id"
          v-if="ruleForm.patrol_type == 2"
        >
          <el-select
            :disabled="czType == 'see'"
            filterable
            v-model="ruleForm.patrol_role_id"
            placeholder="巡检角色"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.title"
              :value="item.id"
              v-for="item in roleList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            v-if="czType == 'add'"
            type="primary"
            @click="submitForm('ruleForm')"
          >
            立即创建
          </el-button>
          <el-button
            v-if="czType == 'edit' || czType == 'see'"
            type="info"
            @click="drawer = false"
          >
            关闭
          </el-button>
          <el-button
            v-if="czType == 'add'"
            type="info"
            @click="resetForm('ruleForm')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-dialog
      :title="operateTitle"
      :visible.sync="dialogOperate"
      width="650px"
      :before-close="handleClose"
    >
      <el-form
        style="max-height: 500px; overflow: auto"
        ref="operateFrom"
        label-width="100px"
        :model="operateFrom"
      >
        <el-form-item
          label="巡检时间"
          prop="patrol_time"
          :rules="{
            required: true,
            message: '请选择巡检时间',
            trigger: 'change',
          }"
        >
          <el-date-picker
            disabled
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="operateFrom.patrol_time"
            type="datetime"
            placeholder="选择巡检时间"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="巡检人"
          prop="user_id"
          :rules="{
            required: true,
            message: '请选择巡检人',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="operateFrom.user_id"
            placeholder="巡检人"
            collapse-tags
            @change="$forceUpdate()"
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="item in renovationUserList"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="审核"
          prop="status"
          :rules="{
            required: true,
            message: '请选择审核状态',
            trigger: 'change',
          }"
        >
          <el-radio-group v-model="operateFrom.status">
            <el-radio :label="1">正常</el-radio>
            <el-radio :label="2">违规</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="remark" label="巡检说明">
          <el-input type="textarea" v-model="operateFrom.remark"></el-input>
        </el-form-item>
        <el-form-item label="上传照片" prop="image">
          <el-upload
            class="avatar-uploaders1"
            :action="ossUpload"
            accept=".jpg,.png,.jpeg"
            name="file[]"
            :data="{ type: 'image' }"
            :headers="{ token: token }"
            list-type="picture-card"
            :show-file-list="true"
            :file-list="fileList"
            :on-remove="handleRemovePic"
            :on-success="handleAvatarSuccess"
            :limit="6"
            :class="fileList.length >= 6 ? 'hide' : ''"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
          ><!-- 已修改 -->
          <div class="pic-tips">最多添加6张图片</div>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogOperate = false">取 消</el-button>
        <el-button type="primary" @click="operateSubmit('operateFrom')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Editor from "@/components/Editor";
import { housing_type } from "@/api/common";
import { openPark, openAgoUser, openRole, openCompany,get_renovation_user_lists } from "@/api/index";
import {
  setAdd,
  setEdit,
  setDel,
  taskList,
  taskInfo,
  taskPunchAdd,
  // intention_user,
} from "@/api/renovation";
import { getToken } from "@/utils/auth";
export default {
  components: { Editor },
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      list: [],
      listLoading: true,
      drawer: false,
      drawerTitle: "添加",
      screen: {
        is_page: 1,
        page: 1,
        page_size: 15,
        company_id: "",
        park_id: "",
        legal_search: "",
        apply_search: "",
      },
      total: 0,
      ruleForm: {},
      rules: {
        park_id: [{ required: true, message: "请选择园区", trigger: "change" }],
        title: [{ required: true, message: "请输入主题", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      czType: "",
      ossUpload: this.$store.state.ossUpload,
      parkList: [],
      screenCompanyList: [],
      roleList: [],
      userList: [],
      operateFrom: {},
      dialogOperate: false,
      operateTitle: "",
      fileList: [],
      renovationUserList:[]
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
    } else {
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    // 下载图片
    downloadByBlob(imgsrc, name) {
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;

        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png");
        var a = document.createElement("a");
        // 创建一个单击事件
        var event = new MouseEvent("click");
        a.download = this.qrCodeName;
        a.href = url;

        // 触发a的单击事件
        a.dispatchEvent(event);
      };
      image.src = imgsrc;
    },
    // 操作提交
    operateSubmit(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              taskPunchAdd(that.operateFrom).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogOperate = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },

    // 图片上传
    handleAvatarSuccess(res, file, fileList) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.operateFrom.image = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
      // this.ruleForm.icon = URL.createObjectURL(file.raw)
    },
    // 图片删除
    handleRemovePic(file, fileList) {
      // if (file.response.data.url) {
      //   this.clearPics.push(file.response.data.url);
      // }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.operateFrom.image = list.join(",");
    },

    // 任务登记
    register() {
      this.operateFrom = {
        user_id: "",
        patrol_task_id: this.ruleForm.id,
        remark: "",
        image: "",
        status: 1,
        patrol_time: this.getNowTime(),
      };
      this.dialogOperate = true;
      this.operateTitle = "添加巡检登记";
    },
    // 获取当前时间
    getNowTime() {
      let dateTime;
      let yy = new Date().getFullYear();
      let MM = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      dateTime =
        yy +
        "-" +
        (MM > 9 ? MM : "0" + MM) +
        "-" +
        (dd > 9 ? dd : "0" + dd) +
        " " +
        hh +
        ":" +
        mm +
        ":" +
        ss;
      return dateTime;
    },
    // 获取装修巡检用户
    getRenovationUser(id, taskId) {
      get_renovation_user_lists({
        park_id: id,
        type: 1,
        is_page: 2,
        task_id: taskId,
      }).then((res) => {
        this.renovationUserList = res.data.lists;
      });
    },

    // 获取用户
    getAgoUser(id, taskId) {
      openAgoUser({ park_id: id, type: 1, is_page: 2, task_id: taskId,is_youke:2 }).then(
        (res) => {
          this.userList = res.data.lists;
        }
      );
    },
    // 获取角色
    getRole(id) {
      const data = {
        is_page: 2,
        is_tree: 1,
        park_id: id,
        type: 1,
        role_type: 2,
      };
      openRole(data).then((res) => {
        this.roleList = res.data.lists;
      });
    },
    parkChange(e) {
      this.screen.company_id = "";
      this.getCompany("screen", e);
    },
    formParkChange() {},
    reset() {
      this.screen = {
        park_id: "",
        legal_search: "",
        apply_search: "",
        company_id: "",
        page: 1,
        page_size: 15,
        is_page: 1,
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 编辑
    handleInfo(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      this.getAgoUser(val.park_id, val.id);
      this.getRenovationUser(val.park_id, val.id)
      this.getRole(val.park_id);
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 查看
    handleSee(val) {
      this.czType = "see";
      this.drawerTitle = "查看";
      // this.ruleForm = val
      this.getAgoUser(val.park_id, val.id);
      // this.getRole(val.park_id);
      this.getInfo(val.id);
      // this.drawer = true;
    },
    // 获取信息
    getInfo(id) {
      var that = this;
      taskInfo({ id: id }).then((res) => {
        // this.domains = res.data.company_role_data
        that.ruleForm = {
          id: res.data.id,
          park_id: Number(res.data.park_id),
          is_scan: res.data.is_scan,
          status: res.data.status,
          patrol_type: res.data.patrol_type,
          patrol_user_id: res.data.patrol_user_id,
          patrol_role_id: res.data.patrol_role_id,
          qrcode: res.data.qrcode,
        };
      });
      this.drawer = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          this.$nextTick(() => {
            this.$refs.ruleForm.clearValidate();
          });
          done();
        })
        .catch(() => {});
    },
    // 获取园区
    getPark() {
      this.parkList = [];
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取企业
    getCompany(type, id, index) {
      var data = {
        park_id: id,
        is_page: 2,
        index: index,
      };
      openCompany(data).then((response) => {
        if (type == "screen") {
          this.screenCompanyList = response.data.lists;
        } else {
          if (type == "add") {
            this.$set(this.companyList, index, response.data.lists);
          }
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
    fetchData() {
      this.listLoading = true;
      taskList(this.screen).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
}
.codeBox {
  padding-left: 30px;
  display: flex;
  align-items: flex-end;
  .codeImg {
    width: 200px;
    height: 220px;
  }
  .btnBox {
    margin-left: 20px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
//去除动画
::v-deep .el-list-enter-active,
::v-deep .el-list-leave-active {
  transition: all 0s;
}
</style>
